"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountDataActionTypes = void 0;
var AccountDataActionTypes = exports.AccountDataActionTypes = /*#__PURE__*/function (AccountDataActionTypes) {
  AccountDataActionTypes["LOAD_ACCOUNT_DATA"] = "api/reducer/GET_ACCOUNT_DATA";
  AccountDataActionTypes["SAVE_ACCOUNT_DATA"] = "api/reducer/SAVE_ACCOUNT_DATA";
  AccountDataActionTypes["INITIATE_PASSWORD_RESET"] = "api/reducer/INITIATE_PASSWORD_RESET";
  AccountDataActionTypes["INITIATE_PASSWORD_RESET_DONE"] = "api/reducer/INITIATE_PASSWORD_RESET_DONE";
  AccountDataActionTypes["INITIATE_PASSWORD_RESET_ERROR"] = "api/reducer/INITIATE_PASSWORD_RESET_ERROR";
  return AccountDataActionTypes;
}({});